/**
 * ヘッダーの高さを :root に css 変数として定義
 *
 * .ist-headerの高さが変更された場合に、:rootに定義したcss変数を更新
 *
 * 追加機能01:
 * .ist-header.ist-header--notSticky の場合は、css変数 を0にする
 */
class HeaderHeight {
  private root: HTMLElement;
  private header: HTMLElement | null;
  private resizeObserver: ResizeObserver;
  private mutationObserver: MutationObserver;

  constructor() {
    this.root = document.documentElement;
    this.header = document.querySelector('.ist-header');

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        // ResizeObserverEntry から正確な高さを取得
        const height = entry.borderBoxSize[0].blockSize;
        this.updateHeight(height);
      }
    });

    this.mutationObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          // クラスが変更された際に高さを再計算
          if (this.header) {
            const height = this.header.getBoundingClientRect().height;
            this.updateHeight(height);
          }
        }
      }
    });

    this.init();
  }

  private init(): void {
    if (this.header) {
      this.resizeObserver.observe(this.header);
      // クラスの変更を監視
      this.mutationObserver.observe(this.header, {
        attributes: true,
        attributeFilter: ['class'],
      });
      // 初期値の設定（getBoundingClientRect()で正確な値を取得）
      this.updateHeight(this.header.getBoundingClientRect().height);
    }
  }

  private updateHeight(height: number): void {
    if (!this.header) return;

    // 追加機能01: .ist-header.ist-header--notSticky の場合は0にする
    if (this.header.classList.contains('ist-header--notSticky')) {
      this.setCssVariable(0, '--ist-headerHeight');
      this.setCssVariable(0, '--ist-headerHeightSp');
      return;
    }

    if (!height) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    // 小数点以下4桁まで保持
    const heightValue = height.toFixed(4);

    if (isMobile) {
      this.setCssVariable(0, '--ist-headerHeightSp');
    } else {
      this.setCssVariable(parseFloat(heightValue), '--ist-headerHeight');
    }
  }

  private setCssVariable(
    value: number,
    variableName: string = '--ist-headerHeight'
  ): void {
    this.root.style.setProperty(variableName, `${value}px`);
  }

  public destroy(): void {
    if (this.header) {
      this.resizeObserver.unobserve(this.header);
      this.mutationObserver.disconnect();
    }
    this.resizeObserver.disconnect();
  }
}

export default HeaderHeight;
